import React, { useEffect, useMemo, useState } from 'react';
import { Collapse, Icon, Tooltip } from 'antd';
import { Button, ColumnProps, Table, Widget } from '@digital/ui';
import { currencyFormat } from '@app/helpers/numbers';
import './custom.css';
import { ClassificacaoServico, excluir, getAll, getUltimaSincronizacao } from '@app/api/classificacaoServico';
import ModalUpdateItem from './ModalUpdateItem';
const { Panel } = Collapse;

const Tabela = () => {
  const [update, setUpdate] = useState(false);
  const [data, setData] = useState<any[]>();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [item, setItem] = useState<ClassificacaoServico | null>(null);
  const [idPai, setIdPai] = useState<string | null>(null);
  const [ultimaSincronizacao, setUltimaSincronizacao] = useState<string | null>(null);

  const onUpdate = () => {
    setUpdate(!update);
    setItem(null);
    setIdPai(null);
  };

  const onExcluir = (id: string) => {
    excluir(id).then(data => {
      if (data.valid) {
        onUpdate();
      }
    });
  };

  const columns = useMemo(() => {
    const columns: ColumnProps<ClassificacaoServico>[] = [];

    columns.push({
      title: 'Item',
      dataIndex: 'indexTexto',
      width: '8%',
    });

    columns.push({
      title: 'Nome',
      render: (_, record) => `${record.fmCodigo ? `${record.fmCodigo} — ` : ''}${record.nome}${record.enabled === false ? ' (inativo)' : ''}`,
      width: '15%',
    });

    columns.push({
      title: 'Descrição',
      dataIndex: 'descricao',
      width: '15%',
    });

    columns.push({
      title: 'Ações',
      dataIndex: 'actions',
      render: (text, record) => {
        return (
          <>
            {!record.gerenciadoTotvs && <Tooltip title="Editar">
              <Button
                icon="commons-edit"
                onClick={() => {
                  setShowModal(true);
                  setItem(record);
                  setIdPai(record.classificacaoServicoPaiId);
                }}
              />
            </Tooltip>}
            {record.nivel < 2 ? (
              <Tooltip title="Adicionar Subitem">
                <Button
                  icon="commons-plus"
                  onClick={() => {
                    setShowModal(true);
                    setItem(null);
                    setIdPai(record.id);
                  }}
                />
              </Tooltip>
            ) : (
              <></>
            )}
            {!record.gerenciadoTotvs && <Tooltip title="Excluir">
              <Button icon="science-minus" onClick={() => onExcluir(record.id)} />
            </Tooltip>}
          </>
        );
      },
      width: '5%',
    });

    return columns;
  }, [data]);

  useEffect(() => {
    getAll().then(data => setData(data));
    getUltimaSincronizacao().then(setUltimaSincronizacao);
  }, [update]);

  return (
    <Collapse activeKey={['tabela']} bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
      <Panel
        key="tabela"
        header={`Classificação de Serviço${
          ultimaSincronizacao ? ` — última sincronização bem-sucedida: ${new Date(ultimaSincronizacao).toLocaleString()}` : ''
        }`}>
        <Widget
          actions={[
            true && (
              <Button
                type="primary"
                onClick={() => {
                  setShowModal(true);
                }}>
                INCLUIR ITEM
              </Button>
            ),
          ]}>
          <Table
            className="tabela-bidcycle"
            columns={columns}
            dataSource={data}
            rowKey={'id'}
            pagination={false}
            expandIcon={props => {
              const expanded = !props.record.children.length
                ? 'ant-table-row-spaced'
                : props.expanded
                ? 'ant-table-row-expanded'
                : 'ant-table-row-collapsed';
              return (
                <div
                  className={`ant-table-row-expand-icon ${expanded}`}
                  onClick={e => props.onExpand(props.record, e)}
                />
              );
            }}
          />
        </Widget>
        <ModalUpdateItem
          showModal={showModal}
          idPai={idPai}
          item={item}
          setShowModal={setShowModal}
          onUpdate={onUpdate}
          setItem={setItem}
        />
      </Panel>
    </Collapse>
  );
};
export default Tabela;
